// actions
export const ADD_NOTIFICATION_LOADED = 'mus/ADD_NOTIFICATION/LOADED';
export const REMOVE_NOTIFICATION_LOADED = 'mus/REMOVE_NOTIFICATION/LOADED';

// creators
export const addNotificationLoaded = (payload) => ({
  type: ADD_NOTIFICATION_LOADED,
  payload,
});
export const removeNotificationLoaded = (payload) => ({ type: REMOVE_NOTIFICATION_LOADED, payload });

// side effects
export const notifyWithSnack =
  ({ message, type = 'success', duration = 3000 }) =>
  (dispatch) =>
    dispatch(addNotificationLoaded({ message, type, duration }));
